<div class="flex flex-col flex-1 py-3 gap-y-2 justify-between min-h-0">

  <div class="flex flex-col flex-1 gap-y-5 overflow-y-auto chat-window" #modalBody>
    <div class="w-full px-3 xs:px-6 xs:max-w-3xl xs:mx-auto flex flex-col gap-y-5">
      <div
        #userQnaElement
        *ngFor="let entry of userQna; let i = index; trackBy: trackByEntryId"
        class="flex flex-col gap-y-5 w-full"
      >
        <div *ngIf="(entry.question.message != '' || entry.question.uploadedFiles?.length) && !isFeedbackRatingTranscript(entry.question.message)" class="w-full flex flex-col gap-y-1">
          <div class="flex justify-end font-normal font-['Open_Sans'] text-xs text-[var(--colorDefault)] opacity-65 gap-[0.625rem]">
            {{entry.question.createdTime| date:'h:mm a'}} <span>{{customerName}}</span>
          </div>
          <div class="flex flex-col items-end gap-2">
            <div *ngIf="entry.question.uploadedFiles?.length" class="flex flex-wrap gap-2 justify-end max-w-full">
              <img
                *ngFor="let file of entry.question.uploadedFiles"
                [src]="file.previewUrl || file.assetUrl"
                [alt]="file.name"
                class="max-w-[10rem] max-h-32 rounded-lg border border-gray-200 object-contain bg-white"
              />
            </div>
            <div *ngIf="entry.question.message != ''" class="flex justify-end">
              <div class="relative chat-user-message text-[var(--textUserBubbleColor)] font-normal font-['Open_Sans'] text-base">
                <span
                  class="word-break"
                  [innerHTML]="entry.question.message | newLineBr"
                ></span>
                <div class="absolute chat-user-message inset-0 z-0 bg-[var(--primaryColor)] opacity-20 pointer-events-none"></div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="entry.answer.receivedFrom == 'VirtualAgent' && (entry.answer.id == '' || entry.answer.id == 'dummyId')" class="flex flex-col gap-y-1">
          <div *ngIf="entry.answer.id == 'dummyId'" class="flex pl-10 font-normal font-['Open_Sans'] text-xs text-[var(--colorDefault)] opacity-65 gap-[0.625rem]">
            <span>AI Service</span> {{entry.answer.createdTime | date:'h:mm a'}}
          </div>
          <div class="flex items-start gap-2">
            <div class="ai-icon-spinner-wrapper">
              <app-spinner-loader [inline]="true" size="icon" [delay]="2000"></app-spinner-loader>
              <div class="ai-icon-inner">
                <span>AI</span>
              </div>
            </div>
            @if (entry.answer.id == '') {
              <div class="typing-loader-align">
                <app-typing-loader [inline]="true"></app-typing-loader>
              </div>
            } @else {
              <div class="flex flex-col">
                <div class="chat-bot-message min-w-0 max-w-full bg-[var(--botBubbleColor)] text-[var(--textBotBubbleColor)] font-normal font-['Open_Sans'] text-base">
                  <span
                    #messageContainer
                    class="typing-text message-container chat-bot-html leading-relaxed break-words"
                  ></span>
                  <app-table-skeleton-loader
                    *ngIf="isStreamingTable(entry.id)"
                  ></app-table-skeleton-loader>
                </div>
                <div class="typing-loader-align">
                  <app-typing-loader [inline]="true"></app-typing-loader>
                </div>
              </div>
            }
          </div>
        </div>

        <div *ngIf="(entry.answer.id == 'ANSWER_id' || (entry.answer.id != '' && entry.answer.receivedFrom != 'VirtualAgent')) && !entry.answer.attachment" class="flex flex-col gap-y-1">
          <div class="flex pl-10 font-normal font-['Open_Sans'] text-xs text-[var(--colorDefault)] opacity-65 gap-[0.625rem]">
            <ng-container *ngIf="entry.answer.receivedFrom == 'VirtualAgent'">
              <span>AI Service</span> {{entry.answer.createdTime | date:'h:mm a'}}
            </ng-container>
            <ng-container *ngIf="entry.answer.receivedFrom != 'VirtualAgent'">
              <span>{{agentName ? agentName : "Human agent"}}</span> {{entry.answer.createdTime | date:'h:mm a'}}
            </ng-container>
          </div>
          <div class="flex items-start gap-2">
            <div *ngIf="entry.answer.receivedFrom == 'VirtualAgent'" class="ai-icon-spinner-wrapper">
              <div class="ai-icon-inner">
                <span>AI</span>
              </div>
            </div>
            <img
              *ngIf="entry.answer.receivedFrom != 'VirtualAgent' && chatBotStyles.humanAgentIcon"
              [src]="chatBotStyles.humanAgentIcon"
              alt="humanAgentIcon"
              class="h-8 w-8 object-contain"
            />

            <div class="chat-bot-message min-w-0 max-w-full bg-[var(--botBubbleColor)] text-[var(--textBotBubbleColor)] font-normal font-['Open_Sans'] text-base">
              <span
                #messageContainer
                class="typing-text message-container chat-bot-html leading-relaxed break-words"
                [innerHTML]="entry.answer.message"
              ></span>
                  <app-table-skeleton-loader
                    *ngIf="isStreamingTable(entry.id)"
                  ></app-table-skeleton-loader>
            </div>
          </div>
        </div>

        <app-rich-message
          *ngIf="entry.answer.attachment && !isAttachmentsComponentType(entry.answer.attachment.type)"
          [message]="entry.answer.message"
          [attachment]="entry.answer.attachment"
          [createdTime]="entry.answer.createdTime"
          (widgetSubmit)="onWidgetSubmit(entry.id, $event)"
        ></app-rich-message>
      </div>
    </div>
  </div>

  <div class="w-full px-3 xs:px-6 xs:max-w-3xl xs:mx-auto flex flex-col justify-between items-center pt-4 gap-2">
    <div
      *ngIf="isConversationClosed"
      class="w-full py-3 text-center text-sm font-semibold font-['Open_Sans'] text-gray-500 border rounded-lg bg-gray-50"
    >
      This conversation has been closed
    </div>
    <div
      *ngIf="!isConversationClosed && smsSwitchCompleted && !smsSwitchPromptOpen"
      class="w-full py-2 text-center text-xs font-['Open_Sans'] text-gray-500 border rounded-lg bg-gray-50"
    >
      {{ smsSwitchConfirmation }} Or keep typing here to continue on Web Chat.
    </div>
    <div
      *ngIf="!isConversationClosed && smsSwitchPromptOpen"
      class="flex border rounded-lg flex-col justify-between items-center gap-2 p-2 w-full"
      [attr.aria-busy]="smsSwitchResolving"
    >
      <p class="w-full text-xs font-['Open_Sans'] text-[var(--colorDefault)] min-h-4">
        {{ smsPromptHint }}
      </p>
      <input
        *ngIf="smsPromptReady && smsNeedsPhone"
        #smsPhoneInput
        type="tel"
        autocomplete="tel"
        class="w-full outline-none border-none resize-none placeholder:text-[var(--textAreaColor)] placeholder:opacity-50 font-normal font-['Open_Sans'] text-sm p-0"
        placeholder="+61412345678"
        [value]="smsSwitchPhone"
        (input)="onSmsPhoneInput($event)"
        (keydown.enter)="confirmSmsSwitch()"
      />
      <p *ngIf="smsSwitchError" class="w-full text-xs text-red-600" role="alert">{{ smsSwitchError }}</p>
      <div class="flex justify-between items-center w-full">
        <button
          type="button"
          class="text-xs font-['Open_Sans'] text-gray-500 px-2 py-2"
          [disabled]="smsSwitchSubmitting"
          (click)="cancelSmsSwitch()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="text-xs font-semibold font-['Open_Sans'] text-[var(--botIconColor)] px-2 py-2 disabled:opacity-40"
          [disabled]="!smsCanSubmit"
          (click)="confirmSmsSwitch()"
        >
          {{ smsSwitchSubmitting ? "Sending…" : "Text me" }}
        </button>
      </div>
    </div>
    <div *ngIf="!isConversationClosed && !smsSwitchPromptOpen" class="flex border rounded-lg flex-col justify-between items-center gap-2 p-2 w-full">

      <!-- Attachment tray: booking widget or live human-agent chat -->
      <div *ngIf="showComposerAttachmentTray" class="flex flex-col gap-2 w-full">
        <div class="flex items-center justify-between gap-2 w-full px-2 py-1.5 rounded-md bg-gray-50 border border-gray-100">
          <div class="flex items-center gap-2 min-w-0">
            <svg viewBox="0 0 24 24" aria-hidden="true" class="w-3 h-5 flex-shrink-0 opacity-70 fill-slate-500">
              <path d="M16.5 6.5 9.2 13.8a3 3 0 1 0 4.24 4.24l7.78-7.78a5 5 0 0 0-7.07-7.07L5.5 11.84a7 7 0 1 0 9.9 9.9l6.36-6.36-1.41-1.41-6.37 6.36a5 5 0 1 1-7.07-7.07l8.65-8.65a3 3 0 0 1 4.24 4.24l-7.78 7.78a1 1 0 1 1-1.41-1.41l7.29-7.3-1.4-1.42z"/>
            </svg>
            <span class="text-xs text-gray-600 truncate">{{ widgetPromptText }}</span>
          </div>
          <div class="flex items-center gap-1.5 flex-shrink-0">
            <label
              class="px-2 py-1 rounded-md text-xs font-semibold bg-white border border-gray-200 text-gray-700 hover:bg-gray-100 transition cursor-pointer select-none"
              [class.opacity-50]="!widgetCanAttachMore"
              [class.cursor-not-allowed]="!widgetCanAttachMore"
            >
              Attach files
              <input
                type="file"
                [attr.accept]="widgetAcceptAttr || null"
                multiple
                hidden
                [disabled]="!widgetCanAttachMore"
                (change)="onTrayFilePicked($event)"
              />
            </label>
          </div>
        </div>

        <div *ngIf="pendingFiles.length > 0" class="w-full overflow-x-auto pb-1 border-b border-gray-100">
          <div class="flex gap-2 w-max">
            <div
              *ngFor="let tile of pendingFiles"
              class="relative flex-shrink-0 w-28 h-24 rounded-xl overflow-hidden border border-gray-200"
              [class.ring-2]="tile.status === 'error'"
              [class.ring-red-500]="tile.status === 'error'"
              [attr.title]="tile.file.name"
            >
              <button
                type="button"
                (click)="onTrayRemove(tile)"
                [disabled]="isSubmittingWidget"
                class="absolute top-1 right-1 z-10 w-5 h-5 rounded-full bg-black/40 text-white flex items-center justify-center text-[10px] leading-none hover:bg-red-500 transition disabled:opacity-50 disabled:cursor-not-allowed"
              >✕</button>
              <img [src]="tile.previewUrl" [alt]="tile.file.name" class="w-full h-full object-contain" />
              <div class="absolute bottom-1.5 left-1.5 px-1.5 py-0.5 rounded bg-black/50 text-white text-[9px] font-semibold uppercase leading-none">
                {{ getTrayExtLabel(tile.file) }}
              </div>
              <div *ngIf="tile.status === 'uploading'" class="absolute inset-0 flex items-center justify-center bg-white/55" aria-label="Uploading">
                <div class="w-4 h-4 rounded-full border-2 border-black/20 border-t-[var(--primaryColor,#2563eb)] animate-spin"></div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="widgetInlineError" class="text-xs text-red-600 px-1" role="alert">{{ widgetInlineError }}</div>
      </div>

      <textarea
        #textAreaRef
        (keydown)="handleKeyDownEnter($event)"
        (input)="onQueryInput($event)"
        id="userQuery"
        rows="1"
        class="w-full outline-none border-none resize-none placeholder:text-[var(--textAreaColor)] placeholder:opacity-50 font-normal font-['Open_Sans'] text-sm p-0 max-h-24 min-h-6 overflow-y-auto"
        placeholder="Write your message here"
        required
      ></textarea>
      <div class="flex justify-between w-full">
        <div class="relative inline-block" #pickerWrapper>
          <button
            class="text-xl p-2 rounded-full hover:bg-gray-100 transition"
            (click)="togglePicker()"
            aria-label="Toggle emoji picker"
          >
            <img
              *ngIf="chatBotStyles.emojiPickerIcon"
              [src]="chatBotStyles.emojiPickerIcon"
              alt="emojiPickerIcon"
              class="h-6 w-6 object-contain" 
              />
          </button>

          <div
            *ngIf="pickerVisible"
            class="absolute left-0 bottom-20 mb-4 z-50"
          >
            <emoji-mart
              (emojiClick)="addEmoji($event)"
              [showPreview]="false"
              [darkMode]="false"
              class="rounded-md"
            ></emoji-mart>
          </div>
        </div>

        <div class="flex items-center">
          <button
            *ngIf="showSmsSwitchButton"
            type="button"
            class="sms-switch-button"
            title="Continue via SMS"
            aria-label="Continue via SMS"
            (click)="openSmsSwitch()"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12z"/>
              <path d="M7 9h10v2H7zm0-3h10v2H7z"/>
            </svg>
            Continue via SMS
          </button>
          <button
          type="submit"
          [disabled]="activeNotesWidget
            ? (isSubmittingWidget || (isUserQueryEmpty() && pendingFiles.length === 0))
            : (isHumanAgentComposerMode
              ? (isSubmittingWidget || (isUserQueryEmpty() && pendingFiles.length === 0))
              : (isUserQueryEmpty() || (!queryResponseReceived && currentAgent !== 'HumanAgent')))"
          [title]="activeNotesWidget || isHumanAgentComposerMode
            ? 'Send message or submit attachments'
            : ((!queryResponseReceived && currentAgent !== 'HumanAgent') ? '' : 'Send Message')"
          (click)="proceedQuery()"
          [ngClass]="{
            'hover:bg-gray-100': userQuery
          }"
          class="rounded-full p-2"
          >
          <img
                *ngIf="chatBotStyles.sendBtnIcon"
                [src]="chatBotStyles.sendBtnIcon"
                alt="sendBtnIcon"
                class="h-6 w-6 object-contain"
          />
        </button>
        </div>
      </div>
    </div>
  </div>

  <div class="w-full px-3 xs:px-6 xs:max-w-3xl xs:mx-auto flex flex-col items-center justify-center h-5">
    <p class="text-xs text-gray-500">
      Powered by <a href="https://www.titandms.com/" target="_blank" class="text-[var(--botIconColor)]">TitanDMS</a>
    </p>
  </div>
</div>
